import { useCallback, useEffect, useState } from 'react';
import type { Mode } from '@/types/entity-mode';

export type SlotListState = {
  editingTiming: boolean;
  setEditingTiming: (value: boolean) => void;
  editingSlotId: string | null;
  setEditingSlotId: (id: string | null) => void;
  editingEditSlotId: string | null;
  setEditingEditSlotId: (id: string | null) => void;
  expandedSlotId: string | null;
  expandedFormType: 'timing' | 'new' | null;
  handleExpandedChange: (slotId: string | null) => void;
  handleFormTypeChange: (slotId: string, formType: 'timing' | 'new' | null) => void;
  isEditingEndLabel: boolean;
  setIsEditingEndLabel: (value: boolean) => void;
  isEditingEndTiming: boolean;
  setIsEditingEndTiming: (value: boolean) => void;
};

export function useSlotListState(mode: Mode): SlotListState {
  const [editingTiming, setEditingTiming] = useState(false);
  const [editingSlotId, setEditingSlotId] = useState<string | null>(null);
  const [editingEditSlotId, setEditingEditSlotId] = useState<string | null>(null);
  const [expandedSlotId, setExpandedSlotId] = useState<string | null>(null);
  const [expandedFormType, setExpandedFormType] = useState<'timing' | 'new' | null>(null);
  const [isEditingEndLabel, setIsEditingEndLabel] = useState(false);
  const [isEditingEndTiming, setIsEditingEndTiming] = useState(false);
  const [, setEditingEdit] = useState(false);

  const handleExpandedChange = useCallback((slotId: string | null) => {
    setExpandedSlotId(slotId);
    if (slotId === null) {
      setExpandedFormType(null);
      setEditingTiming(false);
      setEditingSlotId(null);
      setEditingEdit(false);
      setEditingEditSlotId(null);
    }
  }, []);

  const handleFormTypeChange = useCallback((slotId: string, formType: 'timing' | 'new' | null) => {
    if (formType === null) {
      setExpandedSlotId(null);
      setExpandedFormType(null);
      setEditingTiming(false);
      setEditingSlotId(null);
      setEditingEdit(false);
      setEditingEditSlotId(null);
    } else {
      setEditingTiming(false);
      setEditingSlotId(null);
      setEditingEdit(false);
      setEditingEditSlotId(null);

      setExpandedSlotId(slotId);
      setExpandedFormType(formType);

      if (formType === 'timing') {
        setEditingSlotId(slotId);
        setEditingTiming(true);
      } else if (formType === 'new') {
        setEditingEditSlotId(slotId);
        setEditingEdit(true);
      }
    }
  }, []);

  useEffect(() => {
    queueMicrotask(() => {
      setExpandedSlotId(null);
      setExpandedFormType(null);
      setEditingTiming(false);
      setEditingSlotId(null);
      setEditingEdit(false);
      setEditingEditSlotId(null);
    });
  }, [mode]);

  return {
    editingTiming,
    setEditingTiming,
    editingSlotId,
    setEditingSlotId,
    editingEditSlotId,
    setEditingEditSlotId,
    expandedSlotId,
    expandedFormType,
    handleExpandedChange,
    handleFormTypeChange,
    isEditingEndLabel,
    setIsEditingEndLabel,
    isEditingEndTiming,
    setIsEditingEndTiming,
  };
}

export default useSlotListState;
